const TEXT_VALUES = [
  'accidents_slack_channel',
  'app_reservations_per_hour',
  'booking_advance_days',
  'city',
  'email',
  'garage_address1',
  'garage_address2',
  'garage_city',
  'garage_name',
  'garage_phone_number',
  'garage_state',
  'garage_vehicle_capacity',
  'garage_zipcode',
  'gas_slack_channel',
  'markets_slack_channel',
  'name',
  'ops_slack_channel',
  'overview_url',
  'owner_name',
  'payments_slack_channel',
  'phone_number',
  'registration_pickup_window',
  'reporting_email',
  'state',
  'street_address1',
  'street_address2',
  'tax_rate',
  'zipcode',
];

export default TEXT_VALUES;
